// @ts-nocheck
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';

const InfoCard = ({ message }) => {
  const theme = useTheme();
  return (
    <Box
      p={2}
      mt={4}
      sx={{ background: theme.palette.normalText.backgroundColor }}
      display="flex"
      alignItems="center"
    >
      <InfoOutlinedIcon sx={{ color: theme.palette.secondary.dark }} />
      <Typography variant="body2" ml={1}>
        {message}
      </Typography>
    </Box>
  );
};

export default InfoCard;

InfoCard.propTypes = {
  message: PropTypes.string.isRequired,
};
